export const cleaningServiceData  = [
    {
        caption: "Schnell und zuverlässig",
        text1: "Wir beantworten Ihre Reinigungsanfrage innerhalb von 30 Minuten.",
        text2: "Wir führen schnelle und zuverlässige Reinigungsarbeiten durch."
    },
    {
        caption: "Transparente Preisgestaltung",
        text1: "Peiswert und erstklassige Reinigungsdienste in Berlin und Brandenburg.",
        text2: "Wir setzen alles daran, dass die Qualität den Preis sogar übertrifft. - Wir sind gleichermaßen bestrebt, mit jedem Cent, den wir erhalten, ein Höchstmaß an Sauberkeit und Ordnung zu bieten. - Kostenlose Reinigung nach jedem fünften Termin"
    },
    {
        caption: "Vollversicherung und Rundum-Reinigungsgarantie",
        text1: "Bei uns sind Sie in Sicheren Händen. Wir kümmern uns mit größter Sorgfalt um alle Ihre Anliegen rund um die Reinigung",
        text2: "Wir übernehmen für alle unsere vertraglich vereinbarten Leistungen die volle Haftung gegenüber jedem unserer Kunden."
    },
    {
        caption: "Bestimmung",
        text1: "Wir stellen sämtliche Reinigungsmittel zur Verfügung.",
        text2: "Mopps, Staubsauger, Reinigungsmittel, Bürsten usw."
    }
]

export const cleaningTypes = [
    {
        label: "Grundreinigung",
        city: "Berlin Friedrichshian",
        image1: "./images/basic-cleaning.jpg",
        image2: "./images/basic-cleaning.jpg"
    },
    {
        label: "Tiefenreinigung",
        city: "Berlin Charlottenburg",
        image1: "./images/before-deep.jpg",
        image2: "./images/after-deep.jpg"
    },
    { 
        label: "Einzugs/Auszugsreinigung",
        city: "Berlin Neukölln",
        image1: "./images/move-in-before.jpg",
        image2: "./images/move-in-after.jpg"
    },
    
    {
        label: "Reinigung nach der Party",
        city: "Berlin Lichtenberg",
        image1: "./images/before-party.jpeg",
        image2: "./images/after-party.jpg"
    },
    {
        label: "Reinigung bei Depressionen",
        city: "Berlin Steglitz-Zehlendorf",
        image1: "./images/depression-before.jpg",
        image2: "./images/depression-after.jpg"
    }
]